/**
 * The reader's side of the "already sent" gate.
 *
 * lms-api refuses to save the same notification twice, but a list can
 * still hold copies -- rows saved before that gate existed, or a server
 * that slipped. Whatever arrives, the reader is shown each notification
 * once.
 *
 * "The same notification" matches the API's rule
 * (notification.service.js, sameNotificationWhere): same type, title and
 * message about the same record, sent within two minutes of each other.
 */
const DUPLICATE_WINDOW_MS = 2 * 60 * 1000;
const LINK_FIELDS = ['batchId', 'attendanceId', 'chatId', 'sourceType', 'sourceId'];

export const notificationKey = (n) =>
  [n?.type, n?.title, n?.message, ...LINK_FIELDS.map((field) => n?.[field] || '')].join('\u0001');

/* Keeps the first of each set of copies, in the order given (the lists
   are newest first, so that is the newest). A kept row is unread if any
   of its copies is, so hiding a copy never hides that something is
   waiting. */
export const dedupeNotifications = (list) => {
  const kept = [];
  const lastOfKey = new Map();
  (list || []).forEach((n) => {
    const key = notificationKey(n);
    const at = new Date(n?.createdAt || 0).getTime();
    const twin = lastOfKey.get(key);
    if (twin && Math.abs(twin.at - at) <= DUPLICATE_WINDOW_MS) {
      if (!n.read && twin.row.read) twin.row.read = false;
      twin.at = at;
      return;
    }
    const row = { ...n };
    lastOfKey.set(key, { row, at });
    kept.push(row);
  });
  return kept;
};
